import apiClient from '@/utils/request'
import { nestedQueryFormatter } from '@/utils/query'

import {
  IFeedFormatsPayload,
  IFeedFormatsResponse,
  IFeedFormatResponse,
  IFeedFormatAttributes,
  IFormatResponseCheckResponse
} from '@/apps/traforama/interfaces/feedFormats'

export const fetchItems = async (
  payload: IFeedFormatsPayload
): Promise<IFeedFormatsResponse> => {
  const params = Object.assign(
    { limit: payload.limit, start: payload.start },
    nestedQueryFormatter('filter', payload.filter, false)
  )
  const response = await apiClient.get<IFeedFormatsResponse>('/feed_formats', {
    params
  })
  return response.data
}

export const fetchItem = async (id: string): Promise<IFeedFormatResponse> => {
  const response = await apiClient.get<IFeedFormatResponse>(
    `/feed_formats/${id}`
  )
  return response.data
}

export const createItem = async (
  format: IFeedFormatAttributes
): Promise<IFeedFormatResponse> => {
  const response = await apiClient.post<IFeedFormatResponse>(
    '/feed_formats',
    format
  )
  return response.data
}

export const updateItem = async (
  format: IFeedFormatAttributes
): Promise<IFeedFormatResponse> => {
  const response = await apiClient.put<IFeedFormatResponse>(
    `/feed_formats/${format.id}`,
    format
  )
  return response.data
}

export const destroyItem = async (id: string): Promise<void> => {
  await apiClient.delete(`/feed_formats/${id}`)
}

export const checkItem = async (
  format: IFeedFormatAttributes
): Promise<IFormatResponseCheckResponse> => {
  const response = await apiClient.post<IFormatResponseCheckResponse>(
    `/feed_formats/check`,
    format
  )
  return response.data
}

export const archiveItem = async (id: string): Promise<void> => {
  await apiClient.post(`/feed_formats/${id}/archive`)
}
